import './StateComponents.scss'

import React, { Component } from 'react'
import STATES_HASH from "../Util/states"
import { isSingleDistrictState } from "../Util/DataHelper";

function StateHeader(props) {
  if (props.selectedState) {
    return (
      <div className="state-header">
        <h1 className="header-title">{STATES_HASH[props.selectedState]}</h1>
        <div className="nafsa-logo">
          <img src={`/themes/custom/nafsa/images/nafsa_logo_isev.jpg`} alt="nafsa-logo"/>
        </div>
      </div>
    )
  } else {
    return (<div><strong className="header-subtitle">Benefits from International Students</strong></div>)
  }
}

function StateTotals(props) {
  return (
    <table className="state-totals">
      <tbody>
      <tr>
        <th scope="row">Financial Contribution</th>
        <td>{props.stateData.dollars ? props.stateData.dollars : '$0'}</td>
      </tr>
      <tr>
        <th scope="row">Jobs Supported</th>
        <td>{props.stateData.jobs ? props.stateData.jobs : '0'}</td>
      </tr>
      <tr>
        <th scope="row">International Student Enrolled</th>
        <td>{props.stateData.students ? props.stateData.students : '0'}</td>
      </tr>
      </tbody>
    </table>
  )
}

function TopInstitutions(props) {
  const listInstitutions = props.institutions.map(function (institution, i) {
    return (
      <li key={institution.unitID}>
        <span className="rank">{i + 1}</span>
        <div>
          <strong>{institution.name}</strong><br/>
          {institution.dollars} <em>supporting</em> {institution.jobs} jobs
        </div>
      </li>
    );
  });

  return (
    <div className="top-institutions">
      <h3 className="top-institutions-title">Top Higher Education Institutions <span>(Dollars and Jobs)</span></h3>
      <ul className="top-institutions-body">
        {listInstitutions}
      </ul>
    </div>
  )
}

function NationalBenefits(props) {
  return (
    <div className="national-benefits">
      <div className="national-benefits-body">
        <h3 className="national-benefits-title">The National Benefits
          Beyond {STATES_HASH[props.selectedState]}</h3>
          <p className="national-benefits-text">International students studying at U.S. colleges and universities contribute
          <b>&nbsp;$43.8 billion</b> to the U.S. economy and support <b>378,175 jobs</b>*. For every three international students,
          <b>&nbsp;one U.S. job is created</b> and supported by spending occurring in the higher education, accommodation, dining,
          retail, transportation, telecommunications and health insurance sectors.</p>
      </div>
    </div>
  )
}

function AllInstitutions(props) {
  const institutions = props.institutions;
  const listInstitutions = institutions.map(function (institution, i) {
    return (
      <tr key={institution.unitID}>
        <th className="c-rank" scope="row">{i + 1}</th>
        <td className="c-institution">{institution.name}</td>
        <td className="c-dollars">{institution.dollars}</td>
        <td className="c-jobs">{institution.jobs}</td>
      </tr>
    );
  });

  // Chunking Institutions to print multiple pages if necessary.
  // First Page will have 28 rows + the Table Headers.
  let institutionsOnFirstPage = 23;
  let institutionsOnRemainingPages = 26;
  let chunkedInstitutions = [listInstitutions.slice(0, institutionsOnFirstPage)];
  // Remaining Pages will have 32 rows at most.
  let remainingChunks = listInstitutions.slice(institutionsOnFirstPage);
  remainingChunks = Array.from({ length: Math.ceil(remainingChunks.length / institutionsOnRemainingPages) }, (v, i) =>
    remainingChunks.slice(i * institutionsOnRemainingPages, i * institutionsOnRemainingPages + institutionsOnRemainingPages)
  );
  Array.prototype.push.apply(chunkedInstitutions, remainingChunks);

  // Prepare page chunks to print.
  // Headers are printed only on the first table page.
  const chunkedInstitutionsForPrint = chunkedInstitutions.map(function (institutionChunk, i) {
    return (
      <div className={i + 1 === chunkedInstitutions.length ? 'print-page print-only last-page' : 'print-page print-only'}>
        {i === 0 && props.selectedDistrict &&
          <h3 className="all-institutions-district-title">{STATES_HASH[props.selectedState]}
              <span> District {isSingleDistrictState(props.selectedState) ? 'At large' : props.selectedDistrict}</span></h3>
        }
        {i === 0 &&
          <h3 className="all-institutions-title">Higher Education Institutions
            <span> (Dollars and Jobs)</span></h3>
        }
        {i === 0 &&
          <div className="all-institutions-description">For a more detailed analysis, access NAFSA's <em>International
            Student Economic Value
            Tool</em> at <a href="/economicvalue">nafsa.org/economicvalue</a>.
          </div>
        }
        <table className="all-institutions-body">
          {i === 0 &&
            <thead>
            <tr>
              <th className="c-rank" scope="col">Rank</th>
              <th className="c-institution" scope="col">Institution</th>
              <th className="c-dollars" scope="col">Dollars</th>
              <th className="c-jobs" scope="col">Jobs</th>
            </tr>
            </thead>
          }

          <tbody>
          {institutionChunk}
          </tbody>
        </table>
      </div>
    );
  });

  return (
    <div className="all-institutions">
      {/*For Print*/}
      {chunkedInstitutionsForPrint}

      {/*For Screen*/}
      <div className="print-page screen-only last-page">
        {props.selectedDistrict &&
          <h3 className="all-institutions-district-title">{STATES_HASH[props.selectedState]}
           <span> District {isSingleDistrictState(props.selectedState) ? 'At large' : props.selectedDistrict}</span></h3>
        }
        <h3 className="all-institutions-title">Higher Education Institutions
          <span> (Dollars and Jobs)</span></h3>
        <div className="all-institutions-description">For a more detailed analysis, access NAFSA's <em>International
          Student Economic Value
          Tool</em> at <a href="/economicvalue">nafsa.org/economicvalue</a>.
        </div>
        <table className="all-institutions-body">
          <thead>
          <tr>
            <th className="c-rank" scope="col">Rank</th>
            <th className="c-institution" scope="col">Institution</th>
            <th className="c-dollars" scope="col">Dollars</th>
            <th className="c-jobs" scope="col">Jobs</th>
          </tr>
          </thead>
          <tbody>
          {listInstitutions}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export { StateHeader, StateTotals, TopInstitutions, NationalBenefits, AllInstitutions }
